module.exports = __webpack_public_path__ + "static/media/download_arrow.ebbc8533.svg";